import script from "./MyQrCode.vue?vue&type=script&setup=true&lang=js"
export * from "./MyQrCode.vue?vue&type=script&setup=true&lang=js"

import "./MyQrCode.vue?vue&type=style&index=0&id=62df673e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62df673e"]])

export default __exports__